export default __webpack_public_path__ + "static/media/ProjectTeamImage.cd2fbde6.svg";